import { useStore } from "@nanostores/preact"
import classNames from "utils/preact/class-names"
import { useTranslation } from "./Translation"
import { profile, promo } from "../services/store"
import { ProductDuration } from "../services/support"
import { applyPromoToAmount, monthlyEquivalentAmount } from "../services/promo"
import { PriceDisplay } from "./PriceDisplay"
import css from "../style.module.scss"
import checkIcon from "../static/icon-check--white.svg"
import { useUserData } from "../hooks/useUserData"

export function SubscriptionButtons() {
  const t = useTranslation()
  const user = useStore(profile)
  const promoState = useStore(promo)
  const userData = useUserData()

  if (!userData) return null

  const { currency, products } = userData

  return (
    <div className={css["subscription-buttons"]}>
      {(["annually", "monthly"] as ProductDuration[]).map((type) => {
        const price = products[type].prices[currency.acronym]
        const discountedAmount = applyPromoToAmount(
          price.unit_amount,
          price.currency,
          promoState.validation,
        )
        const monthlyEquivalent = monthlyEquivalentAmount(price.unit_amount, type)
        const discountedMonthlyEquivalent = monthlyEquivalentAmount(discountedAmount, type)

        return (
          <label
            key={type}
            className={classNames({
              [css["radio-label"]]: true,
              [css["is-active"]]: user.subscription === type,
            })}
            htmlFor={`subscription-${type}`}
            data-session-recording="offer"
          >
            <p className={css["subscription-name"]}>{t(`support_${type}`)}</p>
            <p className={css["subscription-price"]}>
              <PriceDisplay
                originalAmount={price.unit_amount}
                discountedAmount={discountedAmount}
                currency={currency}
              />
            </p>
            <p className={css["subscription-comment"]}>
              {type === "annually" ? (
                <>
                  {t("just") || "Just"}{" "}
                  <PriceDisplay
                    originalAmount={monthlyEquivalent}
                    discountedAmount={discountedMonthlyEquivalent}
                    currency={currency}
                  />
                  {t("per_month") || "/month"}
                </>
              ) : (
                t(`offers_comment_${type}`, {
                  price: currency.prefix + (price.unit_amount / 100 / 12).toFixed(2),
                })
              )}
            </p>
            <img src={checkIcon} alt="checkmark" width={12} className={css["check-icon"]} />
            <input
              type="radio"
              name="subscription"
              value={type}
              className={css["radio-input"]}
              id={`subscription-${type}`}
              onChange={() => profile.setKey("subscription", type)}
            />
          </label>
        )
      })}
    </div>
  )
}
